// packages/api-client/queries/scoresheets/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createScoresheetsQueries = (requests, queryClient) => ({
    useListScoresheets: (params, options = {}) => useQuery({
        queryKey: ["scoresheets", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listScoresheets(params);
        },
        ...options,
    }),
    useFindScoresheet: (params, options = {}) => useQuery({
        queryKey: ["scoresheet", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findScoresheet(params);
        },
        ...options,
    }),
    useFindConsolidatedScoresheet: (params, options = {}) => useQuery({
        queryKey: ["consolidated-scoresheet", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findConsolidatedScoresheet(params);
        },
        ...options,
    }),
    useCreateScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetAttrs) => {
            return requests.createScoresheet(scoresheetAttrs);
        },
    }),
    useAutosaveScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetAttrs) => {
            return requests.autosaveScoresheet(scoresheetAttrs);
        },
    }),
    useUpdateScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetAttrs) => {
            return requests.updateScoresheet(scoresheetAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["scoresheets"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateScoresheetsFeedback: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetAttrs) => {
            return requests.updateScoresheetsFeedback(scoresheetAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["scoresheets"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDownloadScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.downloadScoresheet(attrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.deleteScoresheet(attrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["scoresheets"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useFinalizeScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.finalizeScoresheet(attrs);
        },
    }),
    useCreateFinalsScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.createFinalsScoresheet(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["scoresheets"] });
            options.onSuccess?.(...args);
        },
    }),
    useCompareScoresheets: (params, options = {}) => useQuery({
        queryKey: ["compare-scoresheets", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.compareScoresheets(params);
        },
        ...options,
    }),
    useMarkScoresheetAsRead: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.markScoresheetAsRead(attrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["scoresheets"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useValidateScoresheet: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => requests.validateScoresheet(attrs),
    }),
});
//# sourceMappingURL=index.js.map